;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();enum SEARCH_FIELDS {
  q = 'q',
  page = 'page',
  filter_show = 'filter_show',
  filter_item_type = 'filter_item_type',
  filter_duration = 'filter_duration',
  filter_video_type = 'filter_video_type',
  filter_video_availability = 'filter_video_availability',
  filter_descriptive = 'filter_descriptive',
  rank = 'rank',
  country_id = 'country_id',
  station_id = 'station_id',
  start = 'start',
  limit = 'limit',
}

enum RESULT_TYPE_FILTER {
  ALL = 'all',
  CLIP = 'clip',
  FULL_LENGTH = 'full_length',
  PREVIEW = 'preview',
  WEB = 'remote_asset'
}

enum DURATION_FILTER {
  ALL = 'all',
  UNDER_TEN_MINUTES = '0..600',
  TEN_TO_THIRY_MINUTES = '601..1800',
  THIRTY_TO_SIXTY_MINUTES = '1801..3600',
  OVER_SIXTY_MINUTES = '3601..'
}

enum PASSPORT_STATUS_FILTER {
  ALL = 'all',
  PASSPORT = 'mvod',
  NON_PASSPORT = 'public'
}

enum ACCESSIBILITY_FILTER {
  ALL = 'all',
  HAS_AUDIO_DESCRIPTION = 'True'
}

enum SORT_OPTION {
  RELEVANCE = 'relevance',
  MOST_RECENT = '-premiere_date',
  EXPIRING_SOON = 'expire_date'
}

const RESULT_TYPES = [
  {
    label: 'All',
    value: RESULT_TYPE_FILTER.ALL
  },
  {
    label: 'Episodes',
    value: RESULT_TYPE_FILTER.FULL_LENGTH
  },
  {
    label: 'Clip',
    value: RESULT_TYPE_FILTER.CLIP
  },
  {
    label: 'Preview',
    value: RESULT_TYPE_FILTER.PREVIEW
  },
  {
    label: 'Web',
    value: RESULT_TYPE_FILTER.WEB
  },
]

const VIDEO_LENGTHS = [
  {
    label: 'All',
    value: DURATION_FILTER.ALL
  },
  {
    label: 'Under 10 min',
    value: DURATION_FILTER.UNDER_TEN_MINUTES
  },
  {
    label: '10-30 min',
    value: DURATION_FILTER.TEN_TO_THIRY_MINUTES
  },
  {
    label: '30-60 min',
    value: DURATION_FILTER.THIRTY_TO_SIXTY_MINUTES
  },
  {
    label: 'Over 60 min',
    value: DURATION_FILTER.OVER_SIXTY_MINUTES
  },
]

const PASSPORT_STATUS = [
  {
    label: 'All',
    value: PASSPORT_STATUS_FILTER.ALL
  },
  {
    label: 'Passport',
    value: PASSPORT_STATUS_FILTER.PASSPORT
  },
  {
    label: 'Non-Passport',
    value: PASSPORT_STATUS_FILTER.NON_PASSPORT
  },
]

const ACCESSIBILITY_AVAILABILITY = [
  {
    label: 'All',
    value: ACCESSIBILITY_FILTER.ALL
  },
  {
    label: 'Audio Description',
    value: ACCESSIBILITY_FILTER.HAS_AUDIO_DESCRIPTION
  }
]

const SORT_BY = [
  {
    label: 'Relevance',
    value: SORT_OPTION.RELEVANCE
  },
  {
    label: 'Most Recent',
    value: SORT_OPTION.MOST_RECENT
  },
  {
    label: 'Expiring Soon',
    value: SORT_OPTION.EXPIRING_SOON
  },
]

export interface SearchURLParameters {
  q?: string;
  page?: number;
  filter_show?: string;
  filter_item_type?: string;
  filter_duration?: string;
  filter_video_type?: string;
  filter_video_availability?: string;
  filter_descriptive?: boolean;
  rank?: string;
  country_id?: string;
  start?: number;
  limit?: number;
}

export type RESULT_TYPE_VALUES = `${RESULT_TYPE_FILTER}`
export type DURATION_VALUES = `${DURATION_FILTER}`
export type PASSPORT_STATUS_VALUES = `${PASSPORT_STATUS_FILTER}`
export type ACCESSIBILITY_VALUES = `${ACCESSIBILITY_FILTER}`
export type SORT_VALUES = `${SORT_OPTION}`

export type ALL_POSSIBLE_VALUES = RESULT_TYPE_VALUES |
                                  DURATION_VALUES |
                                  PASSPORT_STATUS_VALUES |
                                  ACCESSIBILITY_VALUES |
                                  SORT_VALUES


export {
  SEARCH_FIELDS,
  RESULT_TYPE_FILTER,
  DURATION_FILTER,
  PASSPORT_STATUS_FILTER,
  ACCESSIBILITY_FILTER,
  SORT_OPTION,
  RESULT_TYPES,
  VIDEO_LENGTHS,
  PASSPORT_STATUS,
  ACCESSIBILITY_AVAILABILITY,
  SORT_BY
}
